import { useState } from 'react';
import ContactoHorario from '../forms/contactoForm/ContactoHorario';
import {
  SvgCasa, SvgCorreo, SvgFacebook, SvgInstagram, SvgRecorrido,
  SvgTelefono, SvgTiktok, SvgSobreNosotros, SvgTwitter
} from '../../icons';
import { Link } from 'react-router-dom';

/**
 * 🧩 Footer
 * Componente que representa el pie de página de la web.
 * Contiene:
 *  - Sección de contacto con pop-up de horario
 *  - Enlaces a "Sobre Nosotros"
 *  - Mapa del sitio
 *  - Redes sociales
 *  - Enlaces legales y derechos de autor
 */
const Footer = () => {

  // 🔹 Estado para mostrar u ocultar pop-up de contacto telefónico
  const [showPopup, setShowPopup] = useState(false);

  // 🔹 Función para alternar el pop-up
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <footer className="w-full shadow-md shadow-t bg-white text-black flex flex-col justify-center bottom-0">

        {/* 🔹 Sección principal de iconos e información */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xs:px-2 sm:px-8 md:px-12 lg:px-6 xxl:space-x-12 gap-4 py-4 justify-center">

          {/* ----------------- Contacto ----------------- */}
          <div className="
               group
               relative p-4 h-20
               rounded-xl
           
               /* Bordes que quieres mantener */
               border-r-4 border-b-2 border-zinc-700
           
               /* Fondo elegante tipo cristal */
               bg-white/10 backdrop-blur-xl
           
               /* Sombra premium */
               shadow-xl shadow-black/40
           
               /* Hover glamuroso */
               hover:bg-white/20
               hover:border-blue-700
               hover:shadow-blue-900/40
           
               flex flex-col justify-center items-center space-y-2
               transition-all duration-500 ease-out
             "
          >
            <h3 className="text-center text-md font-bold">Contacto</h3>

            {/* Iconos de contacto */}
            <div className="flex items-center justify-center space-x-6">
              <Link to='/'>
                <SvgCasa className="transform transition-transform duration-300 group-hover:scale-150" /> {/* Icono de casa / inicio */}
              </Link>
              <Link to='#' onClick={togglePopup}>
                <SvgTelefono className="transform transition-transform duration-300 group-hover:scale-125" /> {/* Icono de teléfono, abre pop-up */}
              </Link>
              <Link to='/contacto'>
                <SvgCorreo className="transform transition-transform duration-300 group-hover:scale-150" /> {/* Icono de correo, redirige a contacto */}
              </Link>
            </div>

            {/* Pop-up de contacto telefónico */}

          </div>

          {/* ----------------- Sobre Nosotros ----------------- */}
          <div className="
               group
               relative p-4 h-20
               rounded-xl
           
               /* Bordes que quieres mantener */
               border-r-4 border-b-2 border-zinc-700
           
               /* Fondo elegante tipo cristal */
               bg-white/10 backdrop-blur-xl
           
               /* Sombra premium */
               shadow-xl shadow-black/40
           
               /* Hover glamuroso */
               hover:bg-white/20
               hover:border-blue-700
               hover:shadow-blue-900/40
           
               flex flex-col justify-center items-center space-y-2
               transition-all duration-500 ease-out
             "
          >
            <h3 className="flex flex-grow items-center justify-center"><strong>Sobre Nosotros</strong></h3>
            <div className="flex items-center justify-center space-x-6">
              <Link to='/sobreNosotros'>
                <SvgSobreNosotros className="transform transition-transform duration-300 group-hover:scale-150" />
              </Link>
            </div>
          </div>

          {/* ----------------- Mapa del Sitio ----------------- */}
          <div className="
               group
               relative p-4 h-20
               rounded-xl
           
               /* Bordes que quieres mantener */
               border-r-4 border-b-2 border-zinc-700
           
               /* Fondo elegante tipo cristal */
               bg-white/10 backdrop-blur-xl
           
               /* Sombra premium */
               shadow-xl shadow-black/40
           
               /* Hover glamuroso */
               hover:bg-white/20
               hover:border-blue-700
               hover:shadow-blue-900/40
           
               flex flex-col justify-center items-center space-y-2
               transition-all duration-500 ease-out
             "
          >
            <h3 className='flex flex-grow items-center justify-center'><strong>Recorrido</strong></h3>
            <div className="flex items-center justify-center space-x-6">
              <a
                href="/papeles/Recorrido.pdf"  // ✅ sin /public delante
                target="_blank"                 // 🔗 abre en nueva pestaña
                rel="noopener noreferrer"       // 🔒 seguridad recomendada
              >
                <SvgRecorrido className="transform transition-transform duration-300 group-hover:scale-150" />
              </a>
            </div>
          </div>

          {/* ----------------- Redes Sociales ----------------- */}
          <div className="
               group
               relative p-4 h-20
               rounded-xl
           
               /* Bordes que quieres mantener */
               border-r-4 border-b-2 border-zinc-700
           
               /* Fondo elegante tipo cristal */
               bg-white/10 backdrop-blur-xl
           
               /* Sombra premium */
               shadow-xl shadow-black/40
           
               /* Hover glamuroso */
               hover:bg-white/20
               hover:border-blue-700
               hover:shadow-blue-900/40
           
               flex flex-col justify-center items-center space-y-2
               transition-all duration-500 ease-out
             "
          >
            <h3 className='flex flex-grow items-center justify-center'><strong>Redes Sociales</strong></h3>
            <div className="flex items-center justify-center space-x-6">
              <a
                href="https://www.instagram.com/linkservs/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SvgInstagram className="transform transition-transform duration-300 group-hover:scale-150" />
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61586818906008"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SvgFacebook className="transform transition-transform duration-300 group-hover:scale-125" />
              </a>

              <a
                href="https://www.tiktok.com/@linkservs?lang=es"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SvgTiktok className="transform transition-transform duration-300 group-hover:scale-150" />
              </a>

              <a
                href="https://x.com/Linkservs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SvgTwitter className="transform transition-transform duration-300 group-hover:scale-125" />
              </a>
            </div>

          </div>
        </div>

        {/* ----------------- Footer inferior ----------------- */}
        <div className='flex flex-col md:flex-row justify-between items-center text-white p-4 bg-black text-xs sm:text-sm md:text-base'>

          {/* Izquierda - Enlaces legales */}
          <div className="order-2 md:order-1 flex flex-col md:flex-row text-left items-center space-y-4 md:space-y-0 md:space-x-6 mb-4 md:mb-0">
            <Link to='/politicaPrivacidad' className="hover:text-blue-500 block md:inline whitespace-nowrap">
              Política de privacidad
            </Link>
            <div className="h-6 w-px bg-white hidden md:block"></div>
            <Link to='/avisoLegal' className="hover:text-blue-500 block md:inline whitespace-nowrap">
              Aviso legal
            </Link>
            <div className="h-6 w-px bg-white hidden md:block"></div>
            <Link to='/politicaCookies' rel="noopener noreferrer" className="hover:text-blue-500 block md:inline whitespace-nowrap">
              Política de cookies
            </Link>
          </div>

          {/* Centro - Derechos de autor */}
          <div className="order-1 md:order-2 mb-4 md:mb-0 text-center px-4">
            <span>© 2026 LinkServs. Todos los derechos reservados.</span>
          </div>

          {/* Derecha - Imagen destacada */}
          <div className="order-3 flex justify-end mb-4 md:mb-0">
            <strong>
              <img src="/img/descargar.png" className="w-20" alt="Descargar" />
            </strong>
          </div>
        </div>
      </footer>

      {/* Pop-up de contacto con horario */}
      {showPopup && (
        <div
          className="
                   fixed inset-0
                   z-[99999]
                   bg-black/50
                   flex
                   items-center
                   justify-center
                 "
        >
          <ContactoHorario
            onClose={() => setShowPopup(false)}
            className="w-[90vw] max-w-[480px] mx-auto "
          />
        </div>
      )}

    </>
  );
}

export default Footer;
